module.exports = __webpack_public_path__ + "img/IT.94796b63.webp";